// Returns new date set to midday
export const middayOfTodayDate = () => {
    const date = new Date();

    // The XUI datepicker likes to use midday?
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12);
};

// We need to revert startOfDateUtc to get the datepicker to render to correct date
// eg. 2109-09-32T18:00:00.00000-06:00
export const middayOfDate = (date: Date | null) => {
    if (!date) {
        return date;
    }
    // this offsets the minutes set in startOfDateUtc
    const offsetDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

    // The XUI datepicker likes to use midday?
    return new Date(offsetDate.getFullYear(), offsetDate.getMonth(), offsetDate.getDate(), 12);
};

// When saving to state, we want the date in UTC to send to the backend
// eg. 2109-09-32T00:00:00.00000Z
export const startOfDateUtc = (date: Date): Date => {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, -date.getTimezoneOffset());
};

export const checkIfDateInPast = (dateToCheckUtc: Date) => {
    const dateToCheckUtcTimestamp = dateToCheckUtc.getTime();
    const currentUtcTimestamp = currentUtcDate().getTime();

    return dateToCheckUtcTimestamp < currentUtcTimestamp;
};

export const currentUtcDate = () => {
    const currentDate = new Date();
    return new Date(
        currentDate.getUTCFullYear(),
        currentDate.getUTCMonth(),
        currentDate.getUTCDate(),
        currentDate.getUTCHours(),
        currentDate.getUTCMinutes(),
        currentDate.getUTCSeconds(),
        currentDate.getUTCMilliseconds()
    );
};

/**
 * Converts a date-time into a string representation of a timezone
 * @param date Date object representing UTC time
 * @param timezone Timezone e.g "Pacific/Auckland"
 * @returns a date-time string e.g "2/19/2023, 1:00:00 PM"
 */
export const convertTimezone = (
    date: Date,
    formattingOptions: Intl.DateTimeFormatOptions,
    timezone?: string
): string => {
    // sometimes we may get a timezone that is not supported by the browser
    try {
        if (!timezone) {
            return date.toLocaleString(undefined, { ...formattingOptions, timeZone: 'UTC' }); // default to UTC time
        }

        return date.toLocaleString(undefined, { ...formattingOptions, timeZone: timezone });
    } catch (error) {
        console.warn(`${timezone} is not a valid timezone`);
        return date.toLocaleString(undefined, { ...formattingOptions, timeZone: 'UTC' }); // default to UTC time
    }
};

export const convertTimezoneDisplayDate = (dateUTC: string, timezone?: string) => {
    return convertTimezone(new Date(dateUTC), { month: 'short', day: '2-digit', year: 'numeric' }, timezone);
};
